import { theme as mdsTheme } from 'mds-web-ui'

const { colors, ...rest } = mdsTheme

export const GRAYSCALE = {
  grayMin: '#000',
  gray1: '#111113',
  gray2: '#18191B',
  gray3: '#212225',
  gray4: '#272A2D',
  gray5: '#2E3135',
  gray6: '#363A3F',
  gray7: '#43484E',
  gray8: '#5A6169',
  gray9: '#696E77',
  gray10: '#777B84',
  gray11: '#B0B4BA',
  gray12: '#EDEEF0',
  grayMax: '#FFF'
}

export const theme = {
  ...rest,
  colors: {
    ...colors,
    ...GRAYSCALE,
    background: GRAYSCALE.gray1,
    foreground: GRAYSCALE.gray12
  }
}
